// extracted by mini-css-extract-plugin
module.exports = {"banner":"index-module--banner--2aRiM","resumes":"index-module--resumes--1hmBN","resume":"index-module--resume--2RP9h","first":"index-module--first--Wxw7Q"};